import { QueryFunctionContext } from '@tanstack/react-query'
import { getChoiceGroupsPricing } from 'client/utils/getChoiceGroupPricing'

export const QUERY_KEY = 'pricing'

export const queryPricing = (
  context: QueryFunctionContext<
    [
      string,
      VP.MTT.Queries.TokenEngine.PricingTextQueryKeyParameters & {
        productOptionsHash: string
      },
    ]
  >,
): Promise<Gallery.Pricing.FormattedPrices | null> => {
  const { queryKey } = context
  const [_, { productOptionsHash, pricingResponse, quantity, locale, vatInc, hideVatMessage, hideShippingMessageInVatMessage }] = queryKey

  return getChoiceGroupsPricing({
    locale,
    vatInc,
    productOptionsHash,
    pricingResponse,
    quantity,
    hideShippingMessageInVatMessage,
    hideVatMessage,
  })
}
